/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import React, { memo, PropsWithChildren } from 'react';
import { Link } from 'react-router';

import logo from '../../assets/images/scalefield_logo.svg';
import { createSimpleLayoutStyles } from './SimpleLayout.styles';

export const SimpleLayout = memo<PropsWithChildren>(props => {
  const { children } = props;
  const classes = createSimpleLayoutStyles();

  return (
    <div className={classes.root}>
      <div className={classes.heading}>
        <div className={classes.logoWrap}>
          <Link to="/">
            <img alt="logo img" src={logo} className={classes.logo} />
          </Link>
        </div>
      </div>

      <div className={classes.childrenCenter}>{children}</div>
    </div>
  );
});
